var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-if"},[_c('button',{on:{"click":_vm.onToggleShow}},[_vm._v("切换")]),(_vm.isShow)?_c('div',[_vm._v("前端胖头鱼 显示出来啦")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }